import BankIDIcon from 'assets/icons/ico-bankid.svg?react';
import ExamIcon from 'assets/icons/exam.svg?react';
import ArrowRightIcon from 'assets/icons/arrow-right.svg?react';
import OnlineBankingIcon from 'assets/icons/online-banking1.svg?react';
import SignContractIcon from 'assets/icons/sign-contract1.svg?react';
import Typography from 'components/Typography/Typography';
import s from 'pages/Registration/Intro/InternetBanking.module.scss';
import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';

function BankIDModal() {
  const { t } = useTranslation();
  return (
    <div className={s.bankIdMobileWrapper} data-test="bankId">
      <div className={s.bankIdMobileLayout}>
        <div className={s.bankIdModalTitle}>
          <Typography
            kind="h3"
            size="l"
            fontWeight={700}
            className={s.title}
            dataTest="bankId-title-loan"
          >
            {t('bankIdModal:howToGetALoan')}
          </Typography>
          <BankIDIcon
            className={s.bankIdIcon}
            data-test="bankId-title-loan-icon"
          />
        </div>

        <Typography
          size="m"
          fontWeight={700}
          className={s.mobileTitle}
          dataTest="bankId-works"
        >
          {t('intro:how_it_works')}
        </Typography>
      </div>

      <div className={s.howItWorks}>
        <Typography size="s" dataTest="bankId-works-explanation">
          {t('bankIdModal:howItWorksExplanation')}
        </Typography>
      </div>

      <div className={s.bankIdMobileLayout}>
        <Typography
          fontWeight={700}
          size="m"
          className="pb-2.5"
          dataTest="bankId-works-needed"
        >
          {t('bankIdModal:whatNeeded')}
        </Typography>
      </div>

      <div className={s.instuctions} data-test="bankId-instructions">
        <ul className="list-disc pl-5">
          <li data-test="bankId-instructions-1">
            {t('bankIdModal:toHaveBankAccount')}
          </li>
          <li data-test="bankId-instructions-2">
            {t('bankIdModal:possessBankAccount')}
          </li>
          <li data-test="bankId-instructions-3">
            {t('bankIdModal:verifyBankAccount')}
          </li>
        </ul>
      </div>

      <div className={s.bankIdMobileLayout}>
        <Typography
          fontWeight={700}
          size="m"
          className="mt-4"
          dataTest="bankId-howDoIt"
        >
          {t('bankIdModal:howDoIt')}
        </Typography>
      </div>

      <div className={s.iconsGroup}>
        <div className={s.iconWrapper}>
          <ExamIcon data-test="bankId-exam-icon" />
          <Typography
            className={s.iconDescription}
            size="s"
            fontWeight={500}
            dataTest="bankId-formulaire"
          >
            {t('bankIdModal:fillFormulaire')}
          </Typography>

          <ArrowRightIcon
            className={s.arrowIcon}
            data-test="bankId-arrow-icon-1"
          />
        </div>
        <div className={twMerge(s.iconWrapper, s.middleIconWrapper)}>
          <OnlineBankingIcon data-test="bankId-online-banking" />
          <Typography
            className={s.iconDescription}
            size="s"
            fontWeight={500}
            dataTest="bankId-verifyIncome"
          >
            {t('bankIdModal:verifyIncome')}
          </Typography>
          <ArrowRightIcon
            className={s.arrowIcon}
            data-test="bankId-arrow-icon-1"
          />
        </div>
        <div className={s.iconWrapper}>
          <SignContractIcon data-test="bankId-contract-icon" />
          <Typography
            className={s.iconDescription}
            size="s"
            fontWeight={500}
            dataTest="bankId-signContract"
          >
            {t('bankIdModal:signContract')}
          </Typography>
        </div>
      </div>

      <div className={twMerge('mt-4 mb-2', s.bankIdMobileLayout)}>
        <Typography
          size="xs"
          className={s.smallGreyText}
          dataTest="bankId-footer-1"
        >
          {t('bankIdModal:smallGreyText1')}
        </Typography>
        <Typography
          size="xs"
          className={twMerge(s.smallGreyText, 'mt-2.5')}
          dataTest="bankId-footer-2"
        >
          {t('bankIdModal:smallGreyText2')}
        </Typography>
      </div>
    </div>
  );
}

export default BankIDModal;
